import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "upload_active",
  "use": "upload_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"upload_active\"><path d=\"M13.586 1a1 1 0 0 1 .707.293l3.414 3.414a1 1 0 0 1 .293.707V18a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h10.586ZM9.5 5 6 9h1.313L9 7.071V14h1V7.071L11.688 9H13L9.5 5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol